import React from 'react';
import PropTypes from 'prop-types';

import PropertiesConstants from 'app/shared/constants/PropertiesConstants';

import PropertyCardSkeleton from 'app/shared/components/skeletons/PropertyCardSkeleton';
import PropertyRowSkeleton from 'app/shared/components/skeletons/PropertyRowSkeleton';

// awesome styled grid
import { Container, Row } from '@zillow/zrs-comet';

import { StyledCol } from 'app/shared/components/properties/PropertiesDisplay/StyledComponents';
import { StyledHeaderContainer } from 'app/shared/components/properties/PropertiesViewList/StyledComponents';

const propTypes = {
    viewType: PropTypes.string,
};

const defaultProps = {
    viewType: PropertiesConstants.PROPERTIES_VIEW_TYPE.GRID,
};

const PropertiesPageSkeleton = ({ viewType }) => {
    const skeletonsToShow = [...Array(8)];

    return (
        <Container
            className="PropertiesPageSkeleton PropertiesPage-display-container"
            fluidMobile={true}
        >
            {viewType === PropertiesConstants.PROPERTIES_VIEW_TYPE.LIST
                ? (
                    <>
                        <StyledHeaderContainer />
                        {skeletonsToShow.map((_, idx) => <PropertyRowSkeleton key={idx} />)}
                    </>
                ) : (
                    <Row className="PropertiesDisplay-listings">
                        {skeletonsToShow.map((_, idx) => (
                            <StyledCol
                                className="PropertiesDisplay-StyledCol"
                                xs={12}
                                lg={6}
                                xl={4}
                                key={idx}
                            >
                                <PropertyCardSkeleton />
                            </StyledCol>
                        ))}
                    </Row>
                )
            }
        </Container>
    );
};

PropertiesPageSkeleton.propTypes = propTypes;
PropertiesPageSkeleton.defaultProps = defaultProps;

export default PropertiesPageSkeleton;
